import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaEnvelope, FaPhone } from 'react-icons/fa'; // Import additional icons
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact">
      <h3>Contact Us</h3>
      <p>Have questions or need assistance? Reach out to us:</p>
      
      <div className="contact-details">
        <p><FaEnvelope />  <a href="mailto:chaukematimba2002@gmail.com">support@vibestore.com</a></p>
        <p><FaPhone /> <a href="tel:+27797979796">+27 797979796</a></p>
      </div>

      <div className="social-links">
        <p>Follow us on social media:</p>
        <div className="social-icons">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon">
            <FaFacebook size={30} />
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
            <FaTwitter size={30} />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon">
            <FaInstagram size={30} />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon">
            <FaLinkedin size={30} />
          </a>
        </div>
      </div>

    
        
      
    </div>
  );
};

export default Contact;
